// common/routes.js
import { Icon, Image } from "@chakra-ui/react";
import { HiUsers } from "react-icons/hi";
import {
  MdContacts,
  MdHome,
  MdInsertChartOutlined,
  MdLeaderboard,
  MdLock,
  MdWork,
  MdPeople,
  MdAssignment,
  MdDateRange,
  MdFeedback,
  MdBusiness,
  MdLocalOffer,
  MdVerifiedUser,
  MdGroup,
  MdLibraryBooks,
  MdBuild,
  MdAccountTree,
  MdLocationOn,
  MdAssignmentTurnedIn,
  MdEmail,
  MdCalculate,
  MdAssessment,
  MdPolicy,
  MdCalendarToday,
  MdCardGiftcard,
  MdSettings,
  MdSecurity,
  MdDescription,
  MdCalendarMonth,
  MdLink,
  MdRocketLaunch,
  MdSchedule,
} from "react-icons/md";
import React from "react";
import { AiFillFolderOpen, AiOutlineMail } from "react-icons/ai";
import { FaCalendarAlt, FaRupeeSign, FaTasks, FaWpforms, FaBuilding, FaUsers, FaMapMarkerAlt, FaUserTie } from "react-icons/fa";
import { LuBuilding2 } from "react-icons/lu";
import { PiPhoneCallBold } from "react-icons/pi";
import { FaCreativeCommonsBy } from "react-icons/fa";
import { SiGooglemeet } from "react-icons/si";
import { TbExchange, TbTableColumn } from "react-icons/tb";
import { VscFileSubmodule } from "react-icons/vsc";
import { FiEye } from "react-icons/fi";
import { EditIcon, LockIcon } from "@chakra-ui/icons";


// Import your existing components
import { IoHome } from "react-icons/io5";
import recruitmentIcon from "services/Crm/assets/img/RecruitmentIcon.png";
import { ROLE_PATH } from "common/roles";
import { constant, feedbackConstants } from "./constant";
import RecruitHomePage from "services/Recruit/pages/home";
import Interview from "services/Recruit/pages/interview";
import CreateInterview from "services/Recruit/pages/interviewCreate";
import Referrals from "services/Recruit/pages/referals";
import DepartmentCreate from "services/Recruit/pages/departmentCreate";
import ReferralsCreate from "services/Recruit/pages/referralsCreate";
import Campaign from "services/Recruit/pages/campgain";
import { recruitConstant } from "services/Recruit/constant";
import Application from "services/Recruit/pages/application";
import ApplicationCreate from "services/Recruit/pages/applicationCreate";
import Candidates from "services/Recruit/pages/candidates";
import CandidatesCreate from "services/Recruit/pages/candidatesCreate";
import CompanyPolicy from "services/Recruit/pages/companyPolicy";
import Offers from "services/Recruit/pages/offers";
import Panel from "services/Recruit/pages/pannel";
import PanelCreate from "services/Recruit/pages/panelCreate";
import BgVerification from "services/Recruit/pages/bgVerification";
import BgVerificationCreate from "services/Recruit/pages/bgVerificationCreate.js";
import Feedback from "services/Recruit/pages/feedback";
import CreateFeedback from "services/Recruit/pages/feedbackCreate";
import OfferTemplates from "services/Recruit/pages/offerTemplates";
import EmailTemplates from "services/Recruit/pages/emailTemplates";
import CreateOfferLetter from "services/Recruit/pages/offerLetterCreate";
import TodoList from "services/Todo/pages/todoList";
import DocumentVerification from "services/Recruit/pages/documentVerification";
import LOI from "services/Recruit/pages/loi";

// Lazy loaded components
const Department = React.lazy(() => import("services/Recruit/pages/department"));
const JobProfile = React.lazy(() => import("services/Recruit/pages/jobProfile"));
const Reports = React.lazy(() => import("services/Organization/pages/reports"));
const ScheduledReports = React.lazy(() => import("services/Organization/pages/reports/scheduledReports"));
const CreateOfferLatter = React.lazy(() => import("services/Recruit/pages/offerLetterCreate"));
const MainDashboard = React.lazy(() => import("common/components/default"));
const SSORedirect = React.lazy(() => import("common/components/SSORedirect"));
const User = React.lazy(() => import("common/modules/users"));
const UserView = React.lazy(() => import("common/modules/users/View"));
const Role = React.lazy(() => import("common/components/role"));
const LinkedRole = React.lazy(() => import("common/components/LinkedRoles"));
const Releases = React.lazy(() => import("common/components/releases"));
const CreateJobOpening = React.lazy(() => import("services/Recruit/pages/jobProfileCreate"));
const EventsCalendar = React.lazy(() => import("services/Recruit/pages/EventsCalendar"));

// Static page components for new sections
const StaticPage = ({ title, content }) => (
  <div style={{ padding: '20px' }}>
    <h2>{title}</h2>
    <p>{content || 'This page is under development.'}</p>
  </div>
);

// Wiki & Resources Components
const CompanyPolicies = () => <StaticPage title="Company Policies" content="Company policies and guidelines will be displayed here." />;
const RecruitmentGuide = React.lazy(() => import("services/Recruit/pages/recruitmentGuide"));
const OnboardingChecklistPage = React.lazy(() => import("services/Recruit/pages/onboardingChecklist"));
const ChecklistTemplates = React.lazy(() => import("services/Recruit/pages/checklistTemplates"));
const BackgroundVerification = React.lazy(() => import("services/Recruit/pages/backgroundVerification"));
const BackgroundVerificationForm = React.lazy(() => import("services/Recruit/pages/backgroundVerification/VerificationForm"));

const HolidayCalendar = React.lazy(() => import("services/Resources/pages/holidays"));
const BenefitsGuide = React.lazy(() => import("services/Recruit/pages/benefitsGuide"));

// AI Features Components
const JDCreation = React.lazy(() => import("services/AI/pages/jdCreation"));
const Chatbot = React.lazy(() => import("services/AI/pages/chatbot"));



// Auth Imports
const SignInCentered = React.lazy(() => import("auth/signIn"));
const ForgotPassword = React.lazy(() => import("auth/forgotPassword"));
const ResetPassword = React.lazy(() => import("auth/resetPassword"));
const AdminSetting = React.lazy(() => import("common/components/adminSetting"));

// Main application routes with new structure
export const mainRoutes = [
  {
    name: "Dashboard",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin], // Exclude reviewer
    path: "/dashboard",
    icon: <Icon as={IoHome} width="20px" height="20px" color="inherit" />,
    component: RecruitHomePage,
    module: null,
    order: 1,
    default: true
  },

  // 2. Todo Management (Top-level only for Employees)
  {
    name: "Todo",
    layout: [ROLE_PATH.employee], // Stays top-level for employees
    path: "/todo",
    icon: <Icon as={FaTasks} width="20px" height="20px" color="inherit" />,
    component: TodoList,
    module: "Todo",
    order: 2
  },

  // Performance Management - Category with sub-routes like Recruitment
  {
    name: "Performance",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.reviewer, ROLE_PATH.employee],
    path: "/performance",
    icon: <Icon as={MdAssessment} width="20px" height="20px" color="inherit" />,
    module: "Performance",
    order: 2.5,
    isCategory: true,
    subRoutes: [
      {
        name: "Self Reviews",
        path: "/performance/my-reviews",
        icon: <Icon as={MdAssessment} width="16px" height="16px" color="inherit" />,
        component: React.lazy(() => import("services/Performance/pages/myReviews")),
        module: "My Reviews",
        layout: [ROLE_PATH.employee]
      },
      {
        name: "Peer Reviews",
        path: "/performance/assigned-reviews",
        icon: <Icon as={MdPeople} width="16px" height="16px" color="inherit" />,
        component: React.lazy(() => import("services/Performance/pages/assignedReviews")),
        module: null,
        layout: [ROLE_PATH.employee]
      },
      {
        name: "Team Reviews",
        path: "/performance/team-reviews",
        icon: <Icon as={MdGroup} width="16px" height="16px" color="inherit" />,
        component: React.lazy(() => import("services/Performance/pages/teamReviews")),
        module: "Team Reviews",
        layout: [ROLE_PATH.employee]
      },
      // {
      //   name: "Team Performance",
      //   path: "/performance/team-performance",
      //   icon: <Icon as={MdLeaderboard} width="16px" height="16px" color="inherit" />,
      //   component: React.lazy(() => import("services/Performance/pages/teamPerformance")),
      //   module: "Team Performance",
      //   layout: [ROLE_PATH.employee, ROLE_PATH.superAdmin, ROLE_PATH.user]
      // },
      {
        name: "Review Templates",
        path: "/performance/templates",
        icon: <Icon as={MdDescription} width="16px" height="16px" color="inherit" />,
        component: React.lazy(() => import("services/Performance/pages/reviewTemplates")),
        module: "Review Templates",
        layout: [ROLE_PATH.user, ROLE_PATH.superAdmin]
      },
      {
        name: "Review Cycles",
        path: "/performance/cycles",
        icon: <Icon as={MdCalendarMonth} width="16px" height="16px" color="inherit" />,
        component: React.lazy(() => import("services/Performance/pages/reviewCycles")),
        module: "Review Cycles",
        layout: [ROLE_PATH.user, ROLE_PATH.superAdmin]
      },
      {
        name: "Assignments",
        path: "/performance/assignments",
        icon: <Icon as={MdGroup} width="16px" height="16px" color="inherit" />,
        component: React.lazy(() => import("services/Performance/pages/assignments")),
        module: "Assignments",
        layout: [ROLE_PATH.user, ROLE_PATH.superAdmin]
      },
      {
        name: "Approvals",
        path: "/performance/approvals",
        icon: <Icon as={MdVerifiedUser} width="16px" height="16px" color="inherit" />,
        component: React.lazy(() => import("services/Performance/pages/approvals")),
        module: "Approvals",
        layout: [ROLE_PATH.user, ROLE_PATH.superAdmin]
      },
      {
        name: "Analytics",
        path: "/performance/analytics",
        icon: <Icon as={MdInsertChartOutlined} width="16px" height="16px" color="inherit" />,
        component: React.lazy(() => import("services/Performance/pages/analytics")),
        module: "Performance Analytics",
        layout: [ROLE_PATH.user, ROLE_PATH.superAdmin]
      }
    ]
  },

  // 3. Recruitment Management
  {
    name: "Recruitment",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.reviewer],
    path: "/recruitment",
    icon: <Icon as={MdWork} width="20px" height="20px" color="inherit" />,
    module: "Recruitment",
    order: 3,
    isCategory: true,
    subRoutes: [
      {
        name: "Job Openings",
        path: "/recruitment/jobProfile",
        icon: <Icon as={MdWork} width="16px" height="16px" color="inherit" />,
        component: JobProfile,
        module: "Job Openings"
      },
      {
        name: "Candidates",
        path: "/recruitment/candidates",
        icon: <Icon as={MdPeople} width="16px" height="16px" color="inherit" />,
        component: Candidates,
        module: "Candidates"
      },
      {
        name: "Applications",
        path: "/recruitment/applications",
        icon: <Icon as={MdAssignment} width="16px" height="16px" color="inherit" />,
        component: Application,
        module: "Applications"
      },

      {
        name: "Interviews",
        path: "/recruitment/interviews",
        icon: <Icon as={MdDateRange} width="16px" height="16px" color="inherit" />,
        component: Interview,
        module: "Interviews"
      },
      {
        name: "Feedbacks",
        path: "/recruitment/feedback",
        icon: <Icon as={MdFeedback} width="16px" height="16px" color="inherit" />,
        component: Feedback,
        module: "Feedback"
      },
      {
        name: "Referrals",
        path: "/recruitment/referrals",
        icon: <Icon as={MdGroup} width="16px" height="16px" color="inherit" />,
        component: Referrals,
        module: "Referrals"
      },
      {
        name: "Document Verification",
        path: "/recruitment/document-verification",
        icon: <Icon as={MdVerifiedUser} width="16px" height="16px" color="inherit" />,
        component: DocumentVerification,
        module: "Document Verification",
        layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.reviewer] // Reviewer can access this
      },
      {
        name: "LOI",
        path: "/recruitment/loi",
        icon: <Icon as={MdDescription} width="16px" height="16px" color="inherit" />,
        component: LOI,
        module: "LOI"
      },
      {
        name: "Offers",
        path: "/recruitment/offers",
        icon: <Icon as={MdLocalOffer} width="16px" height="16px" color="inherit" />,
        component: Offers,
        module: "Offers"
      },
      {
        name: "Onboarding Checklist",
        path: "/recruitment/onboarding-checklist",
        icon: <Icon as={MdAssignmentTurnedIn} width="16px" height="16px" color="inherit" />,
        component: OnboardingChecklistPage,
        module: "Onboarding Checklist",
        hideForEmployee: true, // Only visible to recruiter, hiring admin, and admin
        layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.reviewer]
      },

      {
        name: "BG Verification",
        path: "/recruitment/bg-verification",
        icon: <Icon as={MdVerifiedUser} width="16px" height="16px" color="inherit" />,
        component: BackgroundVerification,
        module: "BG Verification",
        layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.employeeNotAllowed] // Exclude employee and reviewer
      },
      //  {
      //   name: "Calendar",
      //   path: "/recruitment/eventsCalendar",
      //   icon: <Icon as={MdCalendarMonth} width="16px" height="16px" color="inherit" />,
      //   component: EventsCalendar,
      //   module: "Calendar"
      // },

    ]
  },

  // 3. Organization (Admin only - not for employees)
  {
    name: "Organization",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin],
    path: "/organization",
    icon: <Icon as={FaBuilding} width="20px" height="20px" color="inherit" />,
    module: "Organization",
    order: 4,
    isCategory: true,
    subRoutes: [
      {
        name: "Departments",
        path: "/organization/departments",
        icon: <Icon as={MdBusiness} width="16px" height="16px" color="inherit" />,
        component: Department,
        module: "Departments"
      },
      {
        name: "Panel",
        path: "/recruitment/panels",
        icon: <Icon as={MdGroup} width="16px" height="16px" color="inherit" />,
        component: Panel,
        module: "Panels"
      },
      {
        name: "Reports",
        path: "/organization/reports",
        icon: <Icon as={MdAssessment} width="16px" height="16px" color="inherit" />,
        component: Reports,
        module: "Reports"
      },
      {
        name: "Scheduled Reports",
        path: "/organization/reports/scheduled",
        icon: <Icon as={MdSchedule} width="16px" height="16px" color="inherit" />,
        component: ScheduledReports,
        module: "Scheduled Reports"
      }
    ]
  },

  // 4. Resources
  {
    name: "Resources",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin],
    path: "/resources",
    icon: <Icon as={MdLibraryBooks} width="20px" height="20px" color="inherit" />,
    module: "Resources",
    order: 5,
    isCategory: true,
    subRoutes: [
      {
        name: "Company Policies",
        path: "/resources/policies",
        icon: <Icon as={MdPolicy} width="16px" height="16px" color="inherit" />,
        component: CompanyPolicy,
        module: "Company Policies"
      },
      {
        name: "Recruitment Guide",
        path: "/resources/recruitment-guide",
        icon: <Icon as={MdLibraryBooks} width="16px" height="16px" color="inherit" />,
        component: RecruitmentGuide,
        module: "Recruitment Guide",
        hideForEmployee: true, // Hide from employees
      },
      {
        name: "Holiday Calendar",
        path: "/resources/holidays",
        icon: <Icon as={MdCalendarToday} width="16px" height="16px" color="inherit" />,
        component: HolidayCalendar,
        module: "Holiday Calendar"
      },
      {
        name: "Benefits Guide",
        path: "/resources/benefits",
        icon: <Icon as={MdCardGiftcard} width="16px" height="16px" color="inherit" />,
        component: BenefitsGuide,
        module: "Benefits Guide"
      }
    ]
  },

  // 5. Tools
  {
    name: "Tools",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin],
    path: "/tools",
    icon: <Icon as={MdBuild} width="20px" height="20px" color="inherit" />,
    module: "Tools",
    order: 6,
    isCategory: true,
    subRoutes: [
      {
        name: "Checklist Templates",
        path: "/tools/checklist-templates",
        icon: <Icon as={MdAssignmentTurnedIn} width="16px" height="16px" color="inherit" />,
        component: ChecklistTemplates,
        module: "Checklist Templates"
      },
      {
        name: "Email Templates",
        path: "/tools/email-templates",
        icon: <Icon as={MdEmail} width="16px" height="16px" color="inherit" />,
        component: EmailTemplates,
        module: "Email Templates"
      },
      {
        name: "Offer Templates",
        path: "/recruitment/offer-templates",
        icon: <Icon as={MdDescription} width="16px" height="16px" color="inherit" />,
        component: OfferTemplates,
        module: "Offer Templates"
      },
      {
        name: "Todo",
        path: "/todo",
        icon: <Icon as={FaTasks} width="16px" height="16px" color="inherit" />,
        component: TodoList,
        module: "Todo",
        layout: [ROLE_PATH.user, ROLE_PATH.superAdmin]
      }
    ]
  },

  // 6. AI Features
  {
    name: "AI Features",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.employeeNotAllowed],
    path: "/ai-features",
    icon: <Icon as={MdRocketLaunch} width="20px" height="20px" color="inherit" />,
    module: "AI Features",
    order: 6,
    isCategory: true,
    subRoutes: [
      {
        name: "JD Creation",
        path: "/ai-features/jd-creation",
        icon: <Icon as={MdDescription} width="16px" height="16px" color="inherit" />,
        component: JDCreation,
        module: "JD Creation"
      },
      {
        name: "Chatbot",
        path: "/ai-features/chatbot",
        icon: <Icon as={MdFeedback} width="16px" height="16px" color="inherit" />,
        component: Chatbot,
        module: "Chatbot"
      }
    ]
  },

  // 7. Administration
  {
    name: "Administration",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.employeeNotAllowed, ROLE_PATH.user],
    path: "/admin",
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />,
    module: "Admin",
    order: 8,
    isCategory: true,
    subRoutes: [
      {
        name: "Users",
        path: "/admin/users",
        icon: <Icon as={HiUsers} width="16px" height="16px" color="inherit" />,
        component: User,
        module: "Users"
      },
      {
        name: "Roles & Permissions",
        path: "/admin/roles",
        icon: <Icon as={FaCreativeCommonsBy} width="16px" height="16px" color="inherit" />,
        component: Role,
        module: null,
        adminOnly: true
      },
      {
        name: "Linked Roles",
        path: "/admin/linked-roles",
        icon: <Icon as={MdLink} width="16px" height="16px" color="inherit" />,
        component: LinkedRole,
        module: "Linked Roles",
        adminOnly: true
      },
      {
        name: "Releases",
        path: "/admin/releases",
        icon: <Icon as={MdRocketLaunch} width="16px" height="16px" color="inherit" />,
        component: Releases,
        module: "Releases",
        adminOnly: true
      }
    ]
  },

  // Hidden routes for create/edit operations (unified paths like old structure)
  {
    name: "Self Review",
    layout: [ROLE_PATH.employee],
    path: "/performance/my-reviews",
    component: React.lazy(() => import("services/Performance/pages/myReviews")),
    module: "My Reviews",
    hidden: true
  },
  {
    name: "Team Reviews",
    layout: [ROLE_PATH.employee],
    path: "/performance/team-reviews",
    component: React.lazy(() => import("services/Performance/pages/teamReviews")),
    module: "Team Reviews",
    // hidden: true
  },
  {
    name: "Peer Reviews",
    layout: [ROLE_PATH.employee],
    path: "/performance/assigned-reviews",
    component: React.lazy(() => import("services/Performance/pages/assignedReviews")),
    module: null,
    hidden: true
  },
  // {
  //   name: "Team Performance",
  //   layout: [ROLE_PATH.employee],
  //   path: "/performance/team-performance",
  //   component: React.lazy(() => import("services/Performance/pages/teamPerformance")),
  //   module: "Team Performance",
  //   hidden: true
  // },
  {
    name: "Offer Letter Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin],
    path: "/recruitment/offerLetterCreate",
    component: CreateOfferLetter,
    module: "Offers",
    hidden: true
  },
  {
    name: "Offer Letter Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin],
    path: "/recruitment/offerLetterCreate/:id",
    component: CreateOfferLetter,
    module: "Offers",
    hidden: true
  },
  {
    name: "Job Opening Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.employee],
    path: "/recruitment/job-opening-create",
    component: CreateJobOpening,
    module: "Job Openings",
    hidden: true
  },
  {
    name: "Job Opening Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.employee],
    path: "/recruitment/job-opening-create/:id",
    component: CreateJobOpening,
    module: "Job Openings",
    hidden: true
  },
  {
    name: "Candidate Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.reviewer, ROLE_PATH.employee],
    path: "/recruitment/candidate-create",
    component: CandidatesCreate,
    module: "Candidates",
    hidden: true
  },
  {
    name: "Candidate Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.reviewer, ROLE_PATH.employee],
    path: "/recruitment/candidate-create/:id",
    component: CandidatesCreate,
    module: "Candidates",
    hidden: true
  },
  {
    name: "Application Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.reviewer, ROLE_PATH.employee],
    path: "/recruitment/application-create",
    component: ApplicationCreate,
    module: "Applications",
    hidden: true
  },
  {
    name: "Application Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.reviewer, ROLE_PATH.employee],
    path: "/recruitment/application-create/:id",
    component: ApplicationCreate,
    module: "Applications",
    hidden: true
  },
  {
    name: "Interview Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.employee],
    path: "/recruitment/interview-create",
    component: CreateInterview,
    module: "Interviews",
    hidden: true
  },
  {
    name: "Interview Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.employee],
    path: "/recruitment/interview-create/:id",
    component: CreateInterview,
    module: "Interviews",
    hidden: true
  },
  {
    name: "Panel Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin],
    path: "/recruitment/panel-create",
    component: PanelCreate,
    module: "Panels",
    hidden: true
  },
  {
    name: "Panel Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin],
    path: "/recruitment/panel-create/:id",
    component: PanelCreate,
    module: "Panels",
    hidden: true
  },
  {
    name: "Feedback Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.employee],
    path: "/recruitment/feedback-create",
    component: CreateFeedback,
    module: "Feedback",
    hidden: true
  },
  {
    name: "Feedback Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.employee],
    path: "/recruitment/feedback-create/:id",
    component: CreateFeedback,
    module: "Feedback",
    hidden: true
  },
  {
    name: "Referral Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.employee],
    path: "/recruitment/referral-create",
    component: ReferralsCreate,
    module: "Referrals",
    hidden: true
  },
  {
    name: "Referral Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin, ROLE_PATH.employee],
    path: "/recruitment/referral-create/:id",
    component: ReferralsCreate,
    module: "Referrals",
    hidden: true
  },
  {
    name: "Department Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin],
    path: "/organization/department-create",
    component: DepartmentCreate,
    module: "Departments",
    hidden: true
  },
  {
    name: "Department Form",
    layout: [ROLE_PATH.user, ROLE_PATH.superAdmin],
    path: "/organization/department-create/:id",
    component: DepartmentCreate,
    module: "Departments",
    hidden: true
  },
  {
    name: "User View",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user, ROLE_PATH.employee],
    path: "/userView/:id",
    component: UserView,
    module: null,
    hidden: true
  },
  {
    name: "User View",
    layout: [ROLE_PATH.superAdmin, ROLE_PATH.user, ROLE_PATH.employee],
    path: "/userView/:id/:tab",
    component: UserView,
    module: null,
    hidden: true
  }
];

// Auth routes
export const authRoutes = [
  {
    name: "Sign In",
    layout: "/auth",
    path: "/sign-in",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignInCentered,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "/forgot-password",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: ForgotPassword,
  },
  {
    name: "Reset Password",
    layout: "/auth",
    path: "/reset-password",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: ResetPassword,
  }
];

// Legacy exports for backward compatibility
export const homeRoutes = mainRoutes.filter(route => route.name === "Dashboard");
export const recruitmentRoutes = mainRoutes;
export const commonRoutes = mainRoutes.filter(route => route.module === "Admin" || route.module === "Users" || route.module === "Roles");

// Default export
const routes = [
  ...authRoutes,
  ...mainRoutes,
];

export default routes;
